import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { ObjectUtil } from '../system-utils/utils/ObjectUtil';
import { DialogService } from './dialog.service';
import { HTTPService } from './http.service';
import { SnackbarService } from './snackbar.service';


export interface CorreiosAuth{
    username:string;
    password:string;
    codadm:string;
    codcartao:string;
    codcontrato:string;
    cnpj:string;
    usernameTrack?:string;
    passwordTrack?:string;
}


@Injectable()
export class CorreiosServices {

    public static TOKEN = new InjectionToken<CorreiosServices>('CorreiosServices');
    constructor(private http:HTTPService, private snackBar:SnackbarService, private dialogServices:DialogService){

    }

    sub:Subscription;
    sub2:Subscription;

    ngOnDestroy(){
        if (this.sub!= null ) {this.sub.unsubscribe();}
        if (this.sub2!= null ) {this.sub2.unsubscribe();}
    }

    getDisponibilidade(codeCompany, codeContract, origem, destino, servico, correiosAut:CorreiosAuth ){
        return new Promise(async (resolve,reject)=>{
           
           let ob = {
            'expressao': "getRequestDataXML(AtendeCliente,Product,\"\",POST,{@BODY},{@HEADER},87,ISO-8859-1)",
            'novo':true,
            'codecontract':codeContract,
            'codecompany': codeCompany,
            'codemktp':87
            }
        
            let body = `<soapenv:Envelope xmlns:soapenv=\"http://schemas.xmlsoap.org/soap/envelope/\" xmlns:cli=\"http://cliente.bean.master.sigep.bsb.correios.com.br/\"> <soapenv:Header/> <soapenv:Body> <cli:verificaDisponibilidadeServico> <codAdministrativo>${correiosAut.codadm}</codAdministrativo> <numeroServico>${servico}</numeroServico> <cepOrigem>${origem}</cepOrigem> <cepDestino>${destino}</cepDestino> <usuario>${correiosAut.username}</usuario> <senha>${correiosAut.password}</senha> </cli:verificaDisponibilidadeServico> </soapenv:Body></soapenv:Envelope>`

            ob['values'] = [
                {
                    key:"@BODY",
                    value: body
                },
                {
                    key:"@HEADER",
                    value:"SOAPAction:\"\""
                }
            ]

            
            this.sub2 = this.http.post(ob, 'FormulaServices/test', false, true, false).subscribe(data => {
                if (ObjectUtil.isNotEmpty(data['resultado'])) {
                    resolve(data['resultado']);
                }
            }, error => {
                reject(this.error(error));
            });
    
        });
    }


    getCliente(codeCompany, codeContract, correiosAut:CorreiosAuth ){
        return new Promise(async (resolve,reject)=>{
           
           let ob = {
            'expressao': "getRequestDataXML(AtendeCliente,Product,\"\",POST,{@BODY},{@HEADER},87,ISO-8859-1)",
            'novo':true,
            'codecontract':codeContract,
            'codecompany': codeCompany,
            'codemktp':87
            }
        
            let body = `<soapenv:Envelope  xmlns:soapenv=\"http://schemas.xmlsoap.org/soap/envelope/\" xmlns:cli=\"http://cliente.bean.master.sigep.bsb.correios.com.br/\"><soapenv:Header/><soapenv:Body><cli:buscaCliente><idContrato>${correiosAut.codcontrato}</idContrato><idCartaoPostagem>${correiosAut.codcartao}</idCartaoPostagem><usuario>${correiosAut.username}</usuario><senha>${correiosAut.password}</senha></cli:buscaCliente></soapenv:Body></soapenv:Envelope>`

            ob['values'] = [
                {
                    key:"@BODY",
                    value: body
                },
                {
                    key:"@HEADER",
                    value:"SOAPAction:\"\""
                }
            ]

            this.sub2 = this.http.post(ob, 'FormulaServices/test', false, true, false).subscribe(data => {
                if (ObjectUtil.isNotEmpty(data['resultado'])) {
                    resolve(data['resultado']);
                }
            }, error => {
                reject(this.error(error));
            });
    
        });
    }


    getRange(codeCompany, codeContract, servico, qtd, correiosAut:CorreiosAuth ){
        return new Promise(async (resolve,reject)=>{
           
           let ob = {
            'expressao': "getRequestDataXML(AtendeCliente,Product,\"\",POST,{@BODY},{@HEADER},87,ISO-8859-1)",
            'novo':true,
            'codecontract':codeContract,
            'codecompany': codeCompany,
            'codemktp':87
            }
        
            let body = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:cli="http://cliente.bean.master.sigep.bsb.correios.com.br/">
                    <soapenv:Header/>
                    <soapenv:Body>
                    <cli:solicitaEtiquetas>
                        <tipoDestinatario>C</tipoDestinatario>
                        <identificador>${correiosAut.cnpj}</identificador>
                        <idServico>${servico}</idServico>
                        <qtdEtiquetas>${qtd}</qtdEtiquetas>
                        <usuario>${correiosAut.username}</usuario>
                        <senha>${correiosAut.password}</senha>
                    </cli:solicitaEtiquetas>
                    </soapenv:Body>
                </soapenv:Envelope>`

            ob['values'] = [
                {
                    key:"@BODY",
                    value: body
                },
                {
                    key:"@HEADER",
                    value:"SOAPAction:\"\""
                }
            ]

            this.sub2 = this.http.post(ob, 'FormulaServices/test', false, true, false).subscribe(data => {
                if (ObjectUtil.isNotEmpty(data['resultado'])) {
                    resolve(data['resultado']);
                }
            }, error => {
                reject(this.error(error));
            });
    
        });
    }


    getPrecoPrazo(codeCompany, codeContract, servico, origem, destino,vlrdeclarado, data, correiosAut:CorreiosAuth ){
        return new Promise(async (resolve,reject)=>{
           
           let ob = {
            'expressao': "getRequestDataXML(CalculaPrecoPrazo,Price,\"\",POST,{@BODY},{@HEADER},87,UTF-8)",
            'novo':true,
            'codecontract':codeContract,
            'codecompany': codeCompany,
            'codemktp':87
            }
        
            let body = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
            <soapenv:Header/>
            <soapenv:Body>
               <tem:CalcPrecoPrazo>
                  <tem:nCdEmpresa>${correiosAut.codadm}</tem:nCdEmpresa>
                  <tem:sDsSenha>${correiosAut.password}</tem:sDsSenha>
                  <tem:nCdServico>${servico['codigo']}</tem:nCdServico>
                  <tem:sCepOrigem>${origem}</tem:sCepOrigem>
                  <tem:sCepDestino>${destino}</tem:sCepDestino>
                  <tem:nVlPeso>${data['peso']}</tem:nVlPeso>
                  <tem:nCdFormato>${data['formato']}</tem:nCdFormato>
                  <tem:nVlComprimento>${data['comprimento']}</tem:nVlComprimento>
                  <tem:nVlAltura>${data['altura']}</tem:nVlAltura>
                  <tem:nVlLargura>${data['largura']}</tem:nVlLargura>
                  <tem:nVlDiametro>${data['diametro']}</tem:nVlDiametro>
                  <tem:sCdMaoPropria>${data['maospropria']}</tem:sCdMaoPropria>
                  <tem:nVlValorDeclarado>${vlrdeclarado}</tem:nVlValorDeclarado>
                  <tem:sCdAvisoRecebimento>${data['avisorecebimento']}</tem:sCdAvisoRecebimento>
               </tem:CalcPrecoPrazo>
            </soapenv:Body>
         </soapenv:Envelope>`

            ob['values'] = [
                {
                    key:"@BODY",
                    value: body
                },
                {
                    key:"@HEADER",
                    value:"SOAPAction:\"http://tempuri.org/CalcPrecoPrazo\";content-type:text/xml; charset=UTF-8"
                }
            ]

            this.sub2 = this.http.post(ob, 'FormulaServices/test', false, true, false).subscribe(data => {
                if (ObjectUtil.isNotEmpty(data['resultado'])) {
                    resolve(data['resultado']);
                }
            }, error => {
                reject(this.error(error));
            });
    
        });
    }


    getTracking(codeCompany, codeContract, objeto, correiosAut:CorreiosAuth ){
        return new Promise(async (resolve,reject)=>{
           
           let ob = {
            'expressao': "getRequestDataXML(Rastro,Track,\"\",POST,{@BODY},{@HEADER},87,UTF-8)",
            'novo':true,
            'codecontract':codeContract,
            'codecompany': codeCompany,
            'codemktp':87
            }
        
            let body =`<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:res="http://resource.webservice.correios.com.br/">
                <soapenv:Header/>
                <soapenv:Body>
                    <res:buscaEventosLista>
                        <usuario>${correiosAut.usernameTrack}</usuario>
                        <senha><![CDATA[${correiosAut.passwordTrack}]]></senha>
                        <tipo>L</tipo>
                        <resultado>T</resultado>
                        <lingua>101</lingua>
                        <objetos>${objeto}</objetos>
                    </res:buscaEventosLista>
                </soapenv:Body>
            </soapenv:Envelope>`;

            ob['values'] = [
                {
                    key:"@BODY",
                    value: body
                },
                {
                    key:"@HEADER",
                    value:"SOAPAction:buscaEventosLista;content-type:text/xml; charset=UTF-8"
                }
            ]

            this.sub2 = this.http.post(ob, 'FormulaServices/test', false, true, false).subscribe(data => {
                if (ObjectUtil.isNotEmpty(data['resultado'])) {
                    resolve(data['resultado']);
                }
            }, error => {
                reject(this.error(error));
            });
    
        });
    }
 

    error(error:HttpErrorResponse){
        if ( error.error ){
            if ( error.error.message){
                let xml:string = error.error.message.split('\n')[1];
                let xml2:string = xml.substring(9,xml.indexOf("Request"));
                
                let doc:Document = new DOMParser().parseFromString(xml2,'text/xml');
                let result = doc.evaluate("//faultstring",doc);
                let node = result.iterateNext();
                
                return node.textContent;
            }
        }
   }
}